/**
 * @file reducers 文件
 * @author fengfaxia(fengfaxia@baidu.com))
 *  Copyright (c) 2018-10-24 Baidu
 */
import {combineReducers} from 'redux';

function userInArrears(state = true, action) {
    switch (action.type) {
        case 'UPDATE_INARREARS':
            return action.inArrears;
        default:
            return state;
    }
}

function userPaid(state = true, action) {
    switch (action.type) {
        case 'UPDATE_PAID':
            return action.paid;
        default:
            return state;
    }
}

function userFreePoint(state = 0, action) {
    switch (action.type) {
        case 'UPDATE_FREE_POINT':
            return action.freePoint;
        default:
            return state;
    }
}

function userInfo(state = '', action) {
    switch (action.type) {
        case 'UPDATE_USER_INFO':
            return action.userName;
        default:
            return state;
    }
}

function token(state = '', action) {
    switch (action.type) {
        case 'UPDATE_TOKEN':
            return action.token;
        default:
            return state;
    }
}

function currentPage(state = '', action) {
    switch (action.type) {
        case 'UPDATE_CURRENT_PAGE':
            return action.currentPage;
        default:
            return state;
    }
}

export default combineReducers({
    userName: userInfo,
    token,
    currentPage,
    freePoint: userFreePoint,
    paid: userPaid,
    inArrears: userInArrears,
});
